import { render, staticRenderFns } from "./ShareholderDocuments.vue?vue&type=template&id=369f151a&scoped=true&"
import script from "./ShareholderDocuments.vue?vue&type=script&lang=js&"
export * from "./ShareholderDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ShareholderDocuments.vue?vue&type=style&index=0&id=369f151a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369f151a",
  null
  
)

export default component.exports